import { gql } from '@apollo/client';

const GET_LOAN = gql`
  query GetLoanAccount($accountId: ID!, $companyId: ID!) {
    account(account_id: $accountId, company_id: $companyId) {
      id
      account_id
      age_months
      asset_class
      borrower_credit_score
      current_balance_cents
      interest_rate_bps
      last_updated_date
      listing {
        id
        name
      }
      loan_terms_months
      maturity_date
      next_payment_date
      original_balance_cents
      first_payment_date
      remaining_loan_terms_months
      servicing_rate_bps
      state
      version
      ... on AutoLoan {
        auto_original_value_cents
        auto_vin
        city
        dti_bps
        ltv_bps
        postal_code
        property_year
        property_description
      }
      ... on HomeLoan {
        city
        dti_bps
        ltv_bps
        occupancy
        postal_code
        property_year
        property_description
        purpose
      }
      ... on HELOCLoan {
        city
        combined_ltv_bps
        credit_line_amount_cents
        draw_period_months
        draw_start_date
        dti_bps
        lien_position
        ltv_bps
        postal_code
        property_description
        property_year
        repayment_period_months
      }
      ... on MarineLoan {
        city
        dti_bps
        ltv_bps
        postal_code
        property_description
        property_year
        charter
        dealer_reserve_cents
        dealer_reserve_bps
      }
    }
  }
`;

export { GET_LOAN };
